import store from '../store/index'
import router from '../router/router'
//--------------
// handle error
//--------------
export default function handleError(err, tag) {
  console.log('ERROR!!!! = ' + err)
  console.log('@ tag ' + tag)
  // alert("error: " + err);
  //--------------
  // access store
  //--------------
  const this_store = store
  const this_router = router
  //-------------------
  // clean-up & logoff
  //-------------------
  this_store.commit('auth/destroyToken')
  this_store.commit('auth/destroyUserProfile')
  this_store.commit('auth/setMessage', err + ' @ tag ' + tag)

  this_router.push({ name: 'logoutView' })
}
